import React from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import { MdModeEdit, MdMenu } from "react-icons/md";
import { FaEdit, FaClipboardList } from "react-icons/fa";
import { HiOutlineSpeakerphone } from "react-icons/hi";
import { FiFileText, FiX } from "react-icons/fi";
import { BsChatLeftText } from "react-icons/bs";
import { MdEqualizer } from "react-icons/md";
import '../../../../Layout/VerticalLayout/sidebar.css';

// ✅ Import your logo
import kagoLogo from '../../../../assets/images/kago-color-white.png';
import { useNavigate } from 'react-router-dom';

// Logo component
const SidebarLogo = ({ isOpen }) => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/dashboard');
  };

  return (
    <div 
      className="sidebar-logo"
      onClick={handleLogoClick}
      style={{
        padding: "6px 16px",
        borderBottom: "1px solid #333",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: "8px",
        color: "#fff",
        flexShrink: 0,
        cursor: "pointer",
        transition: "all 0.2s",
        minHeight: "70px",
      }}
    >
      <img 
        src={kagoLogo} 
        alt="Kago Events"
        style={{
          height: "45px",
          width: "auto",
          maxWidth: "160px",
          objectFit: "contain",
          flexShrink: 0,
        }}
      />
    </div>
  );
};

export const Sidebar = ({
  getEventDetails,
  selectActiveTab,
  setSelectActiveTab,
  isOpen = true,
  toggleSidebar,
  isInPersonEvent = false,
}) => {
  const navigate = useNavigate();

  const openChat = () => {
    window.open(
      "https://tawk.to/chat/65fd674a1ec1082f04da1ddc/1hpitmvma",
      "_blank",
      "noopener,noreferrer"
    );
  };

  const openDoc = () => {
    window.open(
      "https://kago.digital/docs/how-to-register-as-an-event-organiser/getting-started/",
      "_blank",
      "noopener,noreferrer"
    );
  };

  // ✅ Direct tab selection - no navigation, just update state
  const handleTabClick = (tabId) => {
    console.log("📊 Setting active tab to:", tabId); // Debug log
    setSelectActiveTab(tabId);
    
    // Close sidebar on mobile after selection
    if (typeof toggleSidebar === 'function' && window.innerWidth <= 768) {
      toggleSidebar();
    }
  };

  return (
    <>
      {/* ✅ HAMBURGER BUTTON - Shows on mobile when sidebar is CLOSED */}
      {toggleSidebar && !isOpen && (
        <button
          onClick={toggleSidebar}
          aria-label="Open menu"
          className="hamburger-button"
          style={{
            position: "fixed",
            top: "78px",
            left: "15px",
            zIndex: 1101,
            background: "linear-gradient(135deg, #f97316 0%, #e66a0a 100%)",
            border: "none",
            borderRadius: "12px",
            padding: "12px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 15px rgba(249, 115, 22, 0.4)",
            color: "white",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            width: "48px",
            height: "48px",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "linear-gradient(135deg, #fb923c 0%, #f97316 100%)";
            e.currentTarget.style.transform = "translateY(-2px) scale(1.05)";
            e.currentTarget.style.boxShadow = "0 6px 20px rgba(249, 115, 22, 0.5)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "linear-gradient(135deg, #f97316 0%, #e66a0a 100%)";
            e.currentTarget.style.transform = "translateY(0) scale(1)";
            e.currentTarget.style.boxShadow = "0 4px 15px rgba(249, 115, 22, 0.4)";
          }}
        >
          <MdMenu size={24} style={{ color: "white", strokeWidth: 2 }} />
        </button>
      )}

      {/* ✅ SIDEBAR */}
      <div
        className={`vertical-menu ${isOpen ? 'sidebar-open' : 'sidebar-closed'}`}
        style={{
          position: "fixed",
          top: "70px",
          left: 0,
          bottom: 0,
          zIndex: 1100,
          backgroundColor: "#000",
          width: "251px",
          transform: isOpen ? "translateX(0)" : "translateX(-100%)",
          transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          display: "flex",
          flexDirection: "column",
          borderRight: isOpen ? "1px solid #333" : "none",
          overflow: "hidden",
          boxShadow: isOpen ? "2px 0 10px rgba(0, 0, 0, 0.3)" : "none",
          height: "calc(100vh - 50px)",
        }}
      >
        {/* Logo Section */}
        <SidebarLogo isOpen={isOpen} />
        
        {/* Close Button - Top Right - Mobile Only */}
        {toggleSidebar && (
          <button
            onClick={toggleSidebar}
            aria-label="Close menu"
            className="sidebar-close-button"
            style={{
              position: "absolute",
              top: "15px",
              right: "15px",
              background: "rgb(248, 120, 29)",
              border: "none",
              borderRadius: "8px",
              padding: "8px",
              cursor: "pointer",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s ease",
              zIndex: 1100,
              width: "40px",
              height: "40px",
              boxShadow: "0 4px 12px rgba(248, 120, 29, 0.4)",
              opacity: 0,
              pointerEvents: "none",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgb(251, 146, 60)";
              e.currentTarget.style.transform = "rotate(90deg) scale(1.1)";
              e.currentTarget.style.boxShadow = "0 6px 16px rgba(248, 120, 29, 0.5)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "rgb(248, 120, 29)";
              e.currentTarget.style.transform = "rotate(0deg) scale(1)";
              e.currentTarget.style.boxShadow = "0 4px 12px rgba(248, 120, 29, 0.4)";
            }}
          >
            <FiX size={20} style={{ 
              display: "block",
              strokeWidth: 2,
              fontWeight: "bold"
            }} />
          </button>
        )}

        {/* Scrollable Menu Area */}
        <div
          style={{
            overflowY: "auto",
            overflowX: "hidden",
            flex: 1,
            paddingLeft: 16,
            paddingRight: 16,
            paddingTop: 10,
            paddingBottom: 0,
          }}
        >
          <Nav pills className="nav flex-column nav-pills">
            {/* 1. Welcome */}
            <NavItem>
              <NavLink
                active={selectActiveTab === "0"}
                style={{
                  cursor: "pointer",
                  width: "100%",
                  color: "#fff",
                  fontWeight: selectActiveTab === "0" ? "600" : "normal",
                  backgroundColor: selectActiveTab === "0" ? "#f97316" : "transparent",
                  borderRadius: "4px",
                  marginBottom: "8px",
                }}
                onClick={() => handleTabClick("0")}
              >
                <div className="d-flex align-items-center">
                  <FiFileText size={20} color="#fff" />
                  <span className="mx-3">Welcome</span>
                </div>
              </NavLink>
            </NavItem>

            {/* 2. Create landing page */}
            <NavItem>
              <NavLink
                active={selectActiveTab === "9"}
                style={{
                  cursor: "pointer",
                  width: "100%",
                  color: "#fff",
                  fontWeight: selectActiveTab === "9" ? "600" : "normal",
                  backgroundColor: selectActiveTab === "9" ? "#f97316" : "transparent",
                  borderRadius: "4px",
                  marginBottom: "8px",
                }}
                onClick={() => handleTabClick("9")}
              >
                <div className="d-flex align-items-center">
                  <MdModeEdit size={20} color="#fff" />
                  <span className="mx-3">Create landing page</span>
                </div>
              </NavLink>
            </NavItem>

            {/* 3. Setup Registration */}
            <NavItem>
              <NavLink
                active={selectActiveTab === "3"}
                style={{
                  cursor: "pointer",
                  width: "100%",
                  color: "#fff",
                  fontWeight: selectActiveTab === "3" ? "600" : "normal",
                  backgroundColor: selectActiveTab === "3" ? "#f97316" : "transparent",
                  borderRadius: "4px",
                  marginBottom: "8px",
                }}
                onClick={() => handleTabClick("3")}
              >
                <div className="d-flex align-items-center">
                  <FaEdit size={20} color="#fff" />
                  <span className="mx-3">Setup Registration</span>
                </div>
              </NavLink>
            </NavItem>

            {/* 4. Invite Attendees */}
            <NavItem>
              <NavLink
                active={selectActiveTab === "4"}
                style={{
                  cursor: "pointer",
                  width: "100%",
                  color: "#fff",
                  fontWeight: selectActiveTab === "4" ? "600" : "normal",
                  backgroundColor: selectActiveTab === "4" ? "#f97316" : "transparent",
                  borderRadius: "4px",
                  marginBottom: "8px",
                }}
                onClick={() => handleTabClick("4")}
              >
                <div className="d-flex align-items-center">
                  <i className="dripicons-user-group font-size-18" style={{ color: "#fff" }}></i>
                  <span className="mx-3">Invite Attendees</span>
                </div>
              </NavLink>
            </NavItem>

            {/* 5. Sessions – hidden for in-person events */}
            {!isInPersonEvent && (
              <NavItem>
                <NavLink
                  active={selectActiveTab === "5"}
                  style={{
                    cursor: "pointer",
                    width: "100%",
                    color: "#fff",
                    fontWeight: selectActiveTab === "5" ? "600" : "normal",
                    backgroundColor: selectActiveTab === "5" ? "#f97316" : "transparent",
                    borderRadius: "4px",
                    marginBottom: "8px",
                  }}
                  onClick={() => handleTabClick("5")}
                >
                  <div className="d-flex align-items-center">
                    <i className="dripicons-inbox font-size-18" style={{ color: "#fff" }}></i>
                    <span className="mx-3">Sessions</span>
                  </div>
                </NavLink>
              </NavItem>
            )}

            {/* 6. Marketing toolkit */}
            <NavItem>
              <NavLink
                active={selectActiveTab === "7"}
                style={{
                  cursor: "pointer",
                  width: "100%",
                  color: "#fff",
                  fontWeight: selectActiveTab === "7" ? "600" : "normal",
                  backgroundColor: selectActiveTab === "7" ? "#f97316" : "transparent",
                  borderRadius: "4px",
                  marginBottom: "8px",
                }}
                onClick={() => handleTabClick("7")}
              >
                <div className="d-flex align-items-center">
                  <HiOutlineSpeakerphone size={20} color="#fff" />
                  <span className="mx-3">Marketing toolkit</span>
                </div>
              </NavLink>
            </NavItem>

            {/* 7. Event Performance */}
            <NavItem>
              <NavLink
                active={selectActiveTab === "8"}
                style={{
                  cursor: "pointer",
                  width: "100%",
                  color: "#fff",
                  fontWeight: selectActiveTab === "8" ? "600" : "normal",
                  backgroundColor: selectActiveTab === "8" ? "#f97316" : "transparent",
                  borderRadius: "4px",
                  marginBottom: "8px",
                }}
                onClick={() => handleTabClick("8")}
              >
                <div className="d-flex align-items-center">
                  <MdEqualizer size={22} color="#fff" />
                  <span className="mx-3">Event Performance</span>
                </div>
              </NavLink>
            </NavItem>

            {/* 8. Survey ✅ */}
            <NavItem>
              <NavLink
                active={selectActiveTab === "10"}
                style={{
                  cursor: "pointer",
                  width: "100%",
                  color: "#fff",
                  fontWeight: selectActiveTab === "10" ? "600" : "normal",
                  backgroundColor: selectActiveTab === "10" ? "#f97316" : "transparent",
                  borderRadius: "4px",
                  marginBottom: "8px",
                }}
                onClick={() => handleTabClick("10")}
              >
                <div className="d-flex align-items-center">
                  <FaClipboardList size={20} color="#fff" />
                  <span className="mx-3">Survey</span>
                </div>
              </NavLink>
            </NavItem>

            {/* 9. Guide */}
            <NavItem>
              <NavLink
                active={selectActiveTab === "11"}
                style={{
                  cursor: "pointer",
                  width: "100%",
                  color: "#fff",
                  fontWeight: selectActiveTab === "11" ? "600" : "normal",
                  backgroundColor: selectActiveTab === "11" ? "#f97316" : "transparent",
                  borderRadius: "4px",
                  marginBottom: "8px",
                }}
                onClick={openDoc}
              >
                <div className="d-flex align-items-center">
                  <FiFileText size={20} color="#fff" />
                  <span className="mx-3">Guide</span>
                </div>
              </NavLink>
            </NavItem>

            {/* 10. Chat with Expert */}
            <NavItem>
              <NavLink
                active={selectActiveTab === "12"}
                style={{
                  cursor: "pointer",
                  width: "100%",
                  color: "#fff",
                  fontWeight: selectActiveTab === "12" ? "600" : "normal",
                  backgroundColor: selectActiveTab === "12" ? "#f97316" : "transparent",
                  borderRadius: "4px",
                  marginBottom: "0",
                }}
                onClick={openChat}
              >
                <div className="d-flex align-items-center">
                  <BsChatLeftText size={20} color="#fff" />
                  <span className="mx-3">Chat with Expert</span>
                </div>
              </NavLink>
            </NavItem>
          </Nav>
        </div>
      </div>
    </>
  );
};